// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./fonts.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ag-grid-font-family-header: "Poppins_Medium";
  --ag-grid-font-family: "Poppins_Light";
}

.ag-cell-value img {
  max-height: 40px;
}

.ag-theme-alpine,
.ag-theme-alpine-dark {
  --ag-font-size: 0.9rem !important;
  --ag-grid-size: 9px !important;
  --ag-header-column-separator-height: 70%;
  --ag-header-column-resize-handle-height: 25%;
  --ag-icon-size: 24px !important;
  --ag-font-family: var(--ag-grid-font-family) !important;
  --ag-internal-calculated-line-height: 0 !important;
  --ag-header-foreground-color: #ffffff;
  --ag-row-hover-color: rgba(253, 185, 19, 0.5);
}
.ag-theme-alpine .ag-header-cell .ag-header-icon {
  height: 12px;         /* reduce icon height */
  width: 12px;          /* optional: reduce width */
  font-size: 12px;      /* optional: if icon is text-based */
  line-height: 12px;    /* align vertically */
}
.ag-theme-alpine .ag-header-cell .material-icons {
  font-size: 12px;
  vertical-align: middle;
}

.ag-header {
  font-family: Consolas;
  font-size: 1.05rem;
  position: sticky;
  top: 0;
}
.ag-theme-alpine .ag-header {
  background-color: #034EA2;
  color: #ffffff;
  font-weight: bold;
}

.ag-theme-alpine .ag-header-cell-text,
.ag-theme-alpine .ag-header-group-cell-label,
.ag-theme-alpine .ag-header-cell-label {
  color: #ffffff !important;
}

.ag-theme-alpine .ag-header-icon,
.ag-theme-alpine .ag-header-cell-menu-button {
  color: #ffffff !important;
  opacity: 0.85;
}

.ag-header-cell {
  padding: 0 !important;
}

.ag-header-row:not(:first-child)
  .ag-header-cell:not(.ag-header-span-height.ag-header-span-total),
.ag-header-row:not(:first-child)
  .ag-header-group-cell.ag-header-group-cell-with-group {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.ag-theme-alpine .ag-cell.device-cell {
 /*  background-color: #FFC107; default background */
  transition: background-color 0.3s ease;
}

.ag-theme-alpine .ag-cell.device-cell:hover {
  background-color: #FDB913;
  color: #0f172a;
  cursor: pointer;
}
.ag-theme-alpine .ag-cell.device-cell:hover a {
  color: #0f172a !important;
}
.ag-header-group-cell,
.ag-floating-filter {
  padding-left: 0.75rem !important;
  padding-right: 0 !important;
}

.ag-header-cell-resize::after {
  height: 90% !important;
  top: 5% !important;
}

.ag-theme-alpine .ag-floating-filter {
  background-color: #034EA2;
}

.ag-floating-filter-body {
  display: none !important;
}

.ag-floating-filter-button {
  margin-left: 0.75rem !important;
}

.ag-floating-filter-button img {
  filter: invert(1) brightness(2);
}

.headerTable .ag-body {
  max-height: 0;
}

.sticky {
  position: fixed !important;
  top: 0px;
  z-index: 1;
  animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;
  max-width: 97%;
}

.stick-to-bottom {
  position: fixed !important;
  bottom: 0;
  max-width: 97%;
}

.ag-body-viewport.ag-row-animation.ag-layout-auto-height {
  overflow-y: auto;
}

.ag-paging-panel {
  flex-direction: column;
  justify-content: space-around;
  height: fit-content !important;
  gap: 0.5rem;
  padding: 0.5rem;
}

.ag-cell > p {
  padding-left: 0.75rem !important;
  font-family: var(--ag-grid-font-family);
}

.ag-cell {
  padding: 5px !important;
  line-height: 1rem !important;
}

@media screen and (min-width: 756px) {
  .ag-paging-panel {
    flex-direction: row;
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/agGrid.css"],"names":[],"mappings":"AAEA;EACE,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;EACjC,8BAA8B;EAC9B,wCAAwC;EACxC,4CAA4C;EAC5C,+BAA+B;EAC/B,uDAAuD;EACvD,kDAAkD;EAClD,qCAAqC;EACrC,6CAA6C;AAC/C;AACA;EACE,YAAY,UAAU,uBAAuB;EAC7C,WAAW,WAAW,2BAA2B;EACjD,eAAe,OAAO,oCAAoC;EAC1D,iBAAiB,KAAK,qBAAqB;AAC7C;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;AACR;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;EAIE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;CACC,mDAAmD;EAClD,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,QAAQ;EACR,UAAU;EACV,gEAAgE;EAChE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF","sourcesContent":["@import \"./fonts.css\";\n\n:root {\n  --ag-grid-font-family-header: \"Poppins_Medium\";\n  --ag-grid-font-family: \"Poppins_Light\";\n}\n\n.ag-cell-value img {\n  max-height: 40px;\n}\n\n.ag-theme-alpine,\n.ag-theme-alpine-dark {\n  --ag-font-size: 0.9rem !important;\n  --ag-grid-size: 9px !important;\n  --ag-header-column-separator-height: 70%;\n  --ag-header-column-resize-handle-height: 25%;\n  --ag-icon-size: 24px !important;\n  --ag-font-family: var(--ag-grid-font-family) !important;\n  --ag-internal-calculated-line-height: 0 !important;\n  --ag-header-foreground-color: #ffffff;\n  --ag-row-hover-color: rgba(253, 185, 19, 0.5);\n}\n.ag-theme-alpine .ag-header-cell .ag-header-icon {\n  height: 12px;         /* reduce icon height */\n  width: 12px;          /* optional: reduce width */\n  font-size: 12px;      /* optional: if icon is text-based */\n  line-height: 12px;    /* align vertically */\n}\n.ag-theme-alpine .ag-header-cell .material-icons {\n  font-size: 12px;\n  vertical-align: middle;\n}\n\n.ag-header {\n  font-family: Consolas;\n  font-size: 1.05rem;\n  position: sticky;\n  top: 0;\n}\n.ag-theme-alpine .ag-header {\n  background-color: #034EA2;\n  color: #ffffff;\n  font-weight: bold;\n}\n\n.ag-theme-alpine .ag-header-cell-text,\n.ag-theme-alpine .ag-header-group-cell-label,\n.ag-theme-alpine .ag-header-cell-label {\n  color: #ffffff !important;\n}\n\n.ag-theme-alpine .ag-header-icon,\n.ag-theme-alpine .ag-header-cell-menu-button {\n  color: #ffffff !important;\n  opacity: 0.85;\n}\n\n.ag-header-cell {\n  padding: 0 !important;\n}\n\n.ag-header-row:not(:first-child)\n  .ag-header-cell:not(.ag-header-span-height.ag-header-span-total),\n.ag-header-row:not(:first-child)\n  .ag-header-group-cell.ag-header-group-cell-with-group {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.ag-theme-alpine .ag-cell.device-cell {\n /*  background-color: #FFC107; default background */\n  transition: background-color 0.3s ease;\n}\n\n.ag-theme-alpine .ag-cell.device-cell:hover {\n  background-color: #FDB913;\n  color: #0f172a;\n  cursor: pointer;\n}\n.ag-theme-alpine .ag-cell.device-cell:hover a {\n  color: #0f172a !important;\n}\n.ag-header-group-cell,\n.ag-floating-filter {\n  padding-left: 0.75rem !important;\n  padding-right: 0 !important;\n}\n\n.ag-header-cell-resize::after {\n  height: 90% !important;\n  top: 5% !important;\n}\n\n.ag-theme-alpine .ag-floating-filter {\n  background-color: #034EA2;\n}\n\n.ag-floating-filter-body {\n  display: none !important;\n}\n\n.ag-floating-filter-button {\n  margin-left: 0.75rem !important;\n}\n\n.ag-floating-filter-button img {\n  filter: invert(1) brightness(2);\n}\n\n.headerTable .ag-body {\n  max-height: 0;\n}\n\n.sticky {\n  position: fixed !important;\n  top: 0px;\n  z-index: 1;\n  animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;\n  max-width: 97%;\n}\n\n.stick-to-bottom {\n  position: fixed !important;\n  bottom: 0;\n  max-width: 97%;\n}\n\n.ag-body-viewport.ag-row-animation.ag-layout-auto-height {\n  overflow-y: auto;\n}\n\n.ag-paging-panel {\n  flex-direction: column;\n  justify-content: space-around;\n  height: fit-content !important;\n  gap: 0.5rem;\n  padding: 0.5rem;\n}\n\n.ag-cell > p {\n  padding-left: 0.75rem !important;\n  font-family: var(--ag-grid-font-family);\n}\n\n.ag-cell {\n  padding: 5px !important;\n  line-height: 1rem !important;\n}\n\n@media screen and (min-width: 756px) {\n  .ag-paging-panel {\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
